<template>
    <v-btn v-if="fetchingUserInfo" data-test="loading" :loading="fetchingUserInfo" block color="primary"></v-btn>
    <v-btn v-else-if="!userInfo" data-test="create-account" block color="primary" @click="createAccount()">create account</v-btn>
    <v-btn v-else data-test="accept" block color="primary" @click="accept()">continue</v-btn>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'InvitationAuthenticated',
    props: {},
    data() {
        return {}
    },
    created() {},
    computed: {
        ...mapState(['userInfo', 'fetchingUserInfo'])
    },
    methods: {
        async getAuthenticatedProvider() {
            const token = await this.$auth.getTokenSilently()
            const parsedJWT = JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString('binary'))
            const provider = parsedJWT.sub.split('|')[0] === 'google-oauth2' ? 'google' : 'satosa'
            return provider
        },
        async createAccount() {
            const provider = await this.getAuthenticatedProvider()
            this.$router.push({
                name: 'invitation-provider',
                params: { invid: this.$route.params.invid, provider }
            })
        },
        accept() {
            this.$router.push({
                name: 'invitation-accept',
                params: { invid: this.$route.params.invid }
            })
        }
    }
}
</script>
